function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 50 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#044c8a",
    d: "M28.5-.5h7v4a18.436 18.436 0 0 0-6 .5A55.9 55.9 0 0 0 35 8.5c.483.948.65 1.948.5 3-.838.342-1.172 1.008-1 2-1.21.432-2.21 1.099-3 2h-7c-.734-1.208-1.067-2.541-1-4 2.357.163 4.69-.003 7-.5-2.724-1.522-4.724-3.689-6-6.5.66-2.315 1.993-3.981 4-5",
    style: {
      opacity: 0.998
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e89a19",
    d: "M-.5.5v-1h8a19.24 19.24 0 0 1 1 6l-5-4z",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a4f8f",
    d: "M13.5-.5h5l-7 16h-4a108.932 108.932 0 0 1-4-14l5 4 1.5 3a2821.52 2821.52 0 0 0 3.5-9",
    style: {
      opacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#014f91",
    d: "M19.5-.5h4l-2 16h-5a231.596 231.596 0 0 0 3-16",
    style: {
      opacity: 0.999
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005093",
    d: "M41.5-.5h4a86.953 86.953 0 0 0 4 14v2h-5c-.291-1.15-1.124-1.816-2.5-2-1.376.184-2.209.85-2.5 2h-5v-2c.838-.342 1.172-1.008 1-2zm1 6c1.282 1.208 1.282 2.542 0 4-.792-1.2-.792-2.533 0-4",
    style: {
      opacity: 0.993
    }
  }));
};
export default SvgVisa;